import React from 'react'
import Tickets from './components/tickets.container'
import Container from './../../components/layout/container.component'
import AccordionSecondary from '../../components/accordion/accordion-secondary.component'

class Ticket extends React.Component {
	constructor(props) {
		super(props)

		this.getAccordionItems = getAccordionItems.bind(this)
	}
	
	render() {
		return (
			<Container medium>
				<AccordionSecondary
					noAnimated
					noClickable
					arrow={false}
					multiple={false}
					items={getAccordionItems()}
				/>
			</Container>
		)
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Resumo do pedido',
			content: <Tickets />
		}
	]
}

export { Ticket as ModuleRootComponent }
